import { render, staticRenderFns } from "./Linkarticledialog.vue?vue&type=template&id=13e0aa07&lang=html&"
import script from "./Linkarticledialog.vue?vue&type=script&lang=js&"
export * from "./Linkarticledialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports